import React from "react";

import Testimonials from "../misc/Testimonials";
import Pricing from "../misc/Pricing";
import Header from "../misc/Header";

const Home = () => {
  return (
    <React.Fragment>
      <Header />
      <Pricing />
      <Testimonials />
    </React.Fragment>
  );
};

export default Home;

/*
            <Pricing />
            <Testimonials />

*/
